module.exports = __webpack_public_path__ + "img/1533756436.bef99c2f.jpg";